import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	resetSortingButtonDisabled: {
		id: 'servicedesk.queues.agent-view.layout.queues-details.actions.reset-sorting-button.reset-sroting-button-disabled',
		defaultMessage: 'No sorting to reset',
		description: 'Text for rest sorting button in queue when sorting is not applied',
	},
});
